import { j as c } from "./AccesRecoveryIcon-CUPieIxT.js";
const l = () => /* @__PURE__ */ c.jsxs("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ c.jsx(
    "path",
    {
      d: "M10.981 20.247c-4.962 0-8.984 3.98-8.984 8.889s4.022 8.889 8.984 8.889 8.984-3.98 8.984-8.89c0-4.908-4.022-8.888-8.984-8.888M0 29.136c0-6 4.916-10.864 10.981-10.864s10.981 4.864 10.981 10.864S17.046 40 10.981 40 0 35.136 0 29.136",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ c.jsx(
    "path",
    {
      d: "M10.981 26.173c-1.654 0-2.995 1.326-2.995 2.963 0 1.636 1.341 2.963 2.995 2.963s2.995-1.327 2.995-2.963-1.341-2.963-2.995-2.963M5.99 29.136c0-2.727 2.234-4.938 4.991-4.938s4.991 2.21 4.991 4.938-2.234 4.938-4.991 4.938-4.991-2.21-4.991-4.938m26.953 2.963a.993.993 0 0 0-.998.987c0 .546.447.988.998.988a.993.993 0 0 0 .998-.988.993.993 0 0 0-.998-.987m-2.995.987c0-1.636 1.341-2.962 2.995-2.962s2.995 1.326 2.995 2.962-1.34 2.963-2.995 2.963c-1.654 0-2.995-1.326-2.995-2.963",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ c.jsx(
    "path",
    {
      d: "M32.943 28.148c-2.756 0-4.991 2.211-4.991 4.938 0 2.728 2.234 4.939 4.991 4.939s4.992-2.211 4.992-4.939c0-2.727-2.235-4.938-4.992-4.938m-6.988 4.938c0-3.818 3.129-6.913 6.988-6.913s6.988 3.095 6.988 6.913S36.803 40 32.943 40s-6.988-3.095-6.988-6.914",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ c.jsx(
    "path",
    {
      d: "M4.58 0h17.881v9.383c0 .908.279 2.3 1.076 3.362.66.878 1.7 1.576 3.416 1.576h2.995V6.829L27.04 3.95l2.91-2.879 3.992 3.951v9.298h3.494c.843 0 1.366.582 1.648 1.076.29.506.476 1.155.605 1.827.26 1.363.337 3.138.305 4.892a43 43 0 0 1-.376 4.995c-.1.714-.217 1.355-.347 1.863a6 6 0 0 1-.223.7c-.072.178-.195.445-.407.654L37.23 28.93a.5.5 0 0 0-.07.084s.013-.021.035-.076c.04-.097.087-.245.14-.452.106-.41.211-.972.306-1.648.189-1.346.327-3.066.357-4.758.03-1.703-.048-3.322-.271-4.49-.114-.593-.25-.994-.38-1.221l-.046-.074h-.863v5.926h-1.996v-5.926h-.5v5.926h-1.996v-5.926h-.998v5.926H28.95v-5.926h-.998v5.926h-1.997v-5.99c-1.595-.21-2.79-.92-3.646-1.858-2.98.279-5.052-.393-6.409-1.536-1.418-1.195-1.914-2.791-1.924-3.94V1.975H6.4L4.488 22.314 2.5 22.13zm32.675 16.24.008.009zM19.965 32.1h6.988v1.975h-6.988z",
      fill: "currentColor"
    }
  )
] });
export {
  l as Y
};
